import Vue from 'vue'
import Vuex from 'vuex'
import firebase from 'firebase/app'
import 'firebase/auth';
import {db} from '@/services/db.js'
import Modelservice from '@/services/Modelservice'

Vue.use(Vuex)

export default new Vuex.Store({

  state: {
    isAuthenticated: false,
    user : null,
    modelData:{},
    history:{
      mode:'record',
      mutations:[],
      removed_mutations:[]
    },
    order:[],
    media:{},
    options:{
      showTrash:false,
      showSummary:false
    },
    selectedItem:{},
    selectedPath: null,
    app:{
      isLoading:false
    },
    buildMode:{
      frame_type: 'open_frame'
    },
    stage:{
      name:"Stage",
      settings:{
          show_measure:false,
          viewport:'front',
          show_framegaps: true,
          show_perspective: true,
          stage_scale:10,
          stage_background:'backdrop'
      }
    },
    config:[]
  },

  mutations: {

    updateConfig (state, payload) {
      state.config = payload;
    },

    SAVE_CONFIGURATION_STATE(state, payload){
      localStorage.setItem('lastConfig', JSON.stringify(state.config));
    },

    SET_MODEL_DATA(state, payload){
       state.modelData = payload;
    },

    SET_USER(state, payload) {
      state.user = payload;
    },

    SET_USER_DETAILS({user}, payload){
      Vue.set(user, 'details',  payload);
    },

    SET_AUTH(state, payload) {
      state.isAuthenticated = payload;
    },

    SET_OPTIONS (state, payload) {
      state.options = {...state.options, ...payload};
    },

    SET_BUILD_MODE ({buildMode}, payload) {
      Vue.set( buildMode, payload.key, payload.value );
    },

    SET_APP_DATA(state, payload) {
      state.modelData = {...state.modelData,...payload}
    },

    SET_APP_LOADING_STATE(state, payload) {
      state.app.isLoading = payload;
    },

    SET_ITEMS(state, payload) {
      state.config = JSON.parse(JSON.stringify(payload));
    },

    ADD_ITEM(state, item) {

      //Locate the last group in config array
      var lastGroupItem = state.config[state.config.length-1],
          lastFrameObj;
      
      //Store th last group in variable
      if(typeof lastGroupItem !== 'undefined'){
        lastFrameObj= state.modelData.sections[lastGroupItem.frame.id];
      }

      //Add the new item to that last group if the group has any slot available
      if(state.config.length > 0 && lastFrameObj.hasOwnProperty('slots') && lastGroupItem.items.length < lastFrameObj.slots && lastGroupItem.settings.open){

          lastGroupItem.items.push(item);

          //Update size setting to force frame re-render
          lastGroupItem.settings.frame_size = lastGroupItem.items.length;

      }else{
      //Create new framegroup, since no slots were available in the last group

        //Match the frame's material to the new item module's material
        var default_settings = state.modelData.sections.open_frame.settings;

        var material_settings = (item.hasOwnProperty('settings') && item.settings.hasOwnProperty('material'))?{material:item.settings.material}:{};

        //Set the frame ID from the global current build mode
        var frameObj = state.modelData.sections[state.buildMode.frame_type];

        var newItem = {
          frame:{
            id:state.buildMode.frame_type,
            slots: frameObj.slots,
            icon: frameObj.icon,
          },
          items:[item], 
          settings:JSON.parse(JSON.stringify({...default_settings, open:frameObj.slots > 0, ...material_settings}))
        }

        //Add the new framegroup to config array
        state.config.push(newItem);
      }

    },

    ADD_GROUP(state, payload) {

        var frameObj = state.modelData.sections[payload.id];

        if(!frameObj || typeof frameObj === 'undefined'){
          throw 'No frame defined or found.'
        }

        //Default payload settings
        if(!payload.hasOwnProperty('settings')){
          payload.settings = {};
        }

        //Default payload items
        if(!payload.hasOwnProperty('items')){
          payload.items = [];
        }

        var merged_settings = {
          ...frameObj.settings,
          ...payload.settings,
          open: frameObj.slots > payload.items.length
        }
        
        var newFrameItem = {
          rand: Math.floor(Math.random()*10000) + payload.id,
          frame:{
            id:payload.id,
            slots: frameObj.slots,
            icon: frameObj.icon,
          },
          items:payload.items,
          settings:JSON.parse(JSON.stringify(merged_settings))
        }

         //Add the new framegroup to config array
         state.config.splice(payload.index, 0, JSON.parse(JSON.stringify(newFrameItem)));
        
    },

    MOVE_ITEM_OLD({config}, payload) {

      var items = config[payload.group_index].items,
          next_items = [];

      //Move item to next group    
      if (payload.new >= items.length && typeof config[payload.group_index + 1] !== 'undefined' && config[payload.group_index + 1].items.length < 3){
        next_items = config[payload.group_index + 1].items;
        next_items.splice(0, 0, items.splice(payload.old, 1)[0]);
        
        //Force both groups to update size settings
        config[payload.group_index].settings.frame_size = config[payload.group_index].items.length;
        config[payload.group_index + 1].settings.frame_size = config[payload.group_index + 1].items.length;
        return;
      }

      //Move item to previous group
      if(payload.new < 0 && typeof config[payload.group_index - 1] !== 'undefined' && config[payload.group_index - 1].items.length < 3){
        next_items = config[payload.group_index - 1].items;
        next_items.splice(next_items.length, 0, items.splice(payload.old, 1)[0]);
        
        //Force both groups to update size settings
        config[payload.group_index].settings.frame_size = config[payload.group_index].items.length;
        config[payload.group_index - 1].settings.frame_size = config[payload.group_index - 1].items.length;
        return;
      }
      
      
      items.splice(payload.new, 0, items.splice(payload.old, 1)[0]);
      
      //Force group to update size settings
      config[payload.group_index].settings.frame_size = config[payload.group_index].items.length;

    },

    MOVE_ITEM({config}, {source_group, target_group, source_index, target_index}) {

      config[target_group].items.splice(target_index, 0, config[source_group].items.splice(source_index, 1)[0]);

      //Force both groups to update size settings
      config[target_group].settings.frame_size = config[target_group].items.length;
      config[source_group].settings.frame_size = config[source_group].items.length;

    },

    REMOVE_ITEM({config}, payload) {
      var items = config[payload.group_index].items;      
      items.splice(payload.index, 1);

      //Force group to update size
      config[payload.group_index].settings.frame_size = config[payload.group_index].items.length;
    },

    REMOVE_GROUP({config}, payload) {

        if(typeof config[payload.index] !== 'undefined'){
          config.splice(payload.index, 1);
        }

    },

    MOVE_GROUP({config}, payload) {

      var targetIndex = payload.old + payload.new;
      
      if (targetIndex >= config.length) {
        
        var k = targetIndex - config.length + 1;
        while (k--) {
          config.push(undefined);
        }
      }

      if(typeof config[targetIndex] !== 'undefined'){
        config.splice(targetIndex, 0, config.splice(payload.old, 1)[0]);
      }

    },
    
 
    EDIT_ITEM(state, payload){
      
      if(state.selectedItem === payload.item){
        state.selectedItem = {};
        state.selectedPath = [];
      }else{
        state.selectedItem = payload.item;
        state.selectedPath = payload.path;
      }
      
    },

    SET_SLOT_STATUS({config}, payload){  
      if(config[payload.index].hasOwnProperty('settings') && config[payload.index].settings.hasOwnProperty('open')){
        config[payload.index].settings.open = payload.value;
      }
    },

    UPDATE_SETTING(state, payload){     

      payload.item.settings[payload.name] = payload.value;

    },

    UPDATE_PATH_SETTING(state, payload){

      var pathItem = state.config,
          path = payload.path;
          

      // For each item in the path, dig into the object
      for (var i = 0; i < path.length; i++) {
        console.log(pathItem[path[i]]);
      
        // If the item isn't found, return the default (or null)
        if (pathItem[path[i]]){
          pathItem = pathItem[path[i]];
        }
     
       

      }      
      console.log(pathItem);
      
      
      if(pathItem && typeof pathItem !== 'undefined' && pathItem.hasOwnProperty('settings') && pathItem.settings.hasOwnProperty(payload.name)){
        pathItem.settings[payload.name] = payload.value;
      }


      
    },

    UPDATE_ADDONS(state, payload){
      state.selectedItem.settings.addons[payload.name] = payload.value;
    },

    UPDATE_PATH_ADDONS(state, payload){
      var pathItem = state.config,
          path = payload.path;
          

      // For each item in the path, dig into the object
      for (var i = 0; i < path.length; i++) {

          console.log('trying ' + path[i]);
          
        // If the item isn't found, return the default (or null)
        if (pathItem[path[i]]){
          pathItem = pathItem[path[i]];
        }
     
      
      }      
      
      if(pathItem){
        pathItem.settings.addons[payload.name] = payload.value;
      }

    
    },

    SET_STAGE_SCALE(state, payload){      
      state.stage.settings.stage_scale = payload;
    },

    SET_ORDER(state, payload){    
     
        
      state.order = payload;
    }
   
  },

  actions: {   

    initConfig({commit, dispatch}){

    
      if( localStorage.getItem('lastConfig') !== 'null' && localStorage.getItem('lastConfig')) 
      
      {
        let config = JSON.parse(localStorage.getItem('lastConfig'))
        
        commit('SET_ITEMS', config);
      }
      
    },

    toggleSummary({commit, context, getters}){

      var val = getters.secondaryContent != 'summary';

      commit('EDIT_ITEM',{
          item:{},
          path:[]
      });

      commit('SET_OPTIONS',{
          showSummary: val
      });
    },

    initFirebaseAuth({ commit, dispatch }){
      
      firebase.auth().onAuthStateChanged(function(user) {
        if (user) {
  
          commit('SET_USER', user);
          commit('SET_AUTH', true);

          dispatch('getUserDetails', user.uid);
          // ...
        } else {
          commit('SET_USER', null);
          commit('SET_AUTH', false);
        }
        // ...
      });
     
    },

    commitHistory({state, commit}, payload){
      

      if(payload && typeof payload !== 'undefined'){

      //Pause recording of mutations while re-committing saved ones
       state.history.mode = 'hold';

      var mutations = payload;
    
      //Loop through recorded commits and re-commit
      for (let index = 0; index < mutations.length; index++) {

        let mutation = JSON.parse(mutations[index]);

        //Change to history friendly mutations
        if(mutation.type === 'UPDATE_SETTING'){
          mutation.type = 'UPDATE_PATH_SETTING';
        }

        //Change to history friendly mutations
        if(mutation.type === 'UPDATE_ADDONS'){
          mutation.type = 'UPDATE_PATH_ADDONS';
        }
       
        //commit the action mutation
        commit(`${mutation.type}`, mutation.payload);
    
      }

      commit('SAVE_CONFIGURATION_STATE');
      state.history.mode = 'record';

    }
       

    },

    undo({state, commit, dispatch}, payload){

    
      //Clear configuration onject
      commit('updateConfig', []);
      state.history.removed_mutations.push(state.history.mutations.pop());
      
      dispatch('commitHistory', state.history.mutations);

      //Remove any reference to selected item
      commit('EDIT_ITEM', {path:[], item:{}});

      
    },

    redo({state, commit, dispatch}, payload){

    
      //Clear configuration onject
      commit('updateConfig', []);
      state.history.mutations.push(state.history.removed_mutations.pop());

      dispatch('commitHistory', state.history.mutations);

      //Remove any reference to selected item
      commit('EDIT_ITEM', {path:[], item:{}});

      
    },


    playSound (context, payload) {

      
      if(payload) {
        var audio = new Audio(payload);

        audio.play();
      }
    },

    getUserDetails({ commit }, id) {
      
      db.collection('users').doc(id).get().then((docSnapshot) => {
        
        if (!docSnapshot.exists) return;
        let data = docSnapshot.data();
        // continue your code
      
        commit('SET_USER_DETAILS', data);
      
      })

      .catch((error) => {

      });

    },

    userLogin({ commit, dispatch }, payload) {

      dispatch('SET_APP_LOADING_STATE', true);
      
      firebase.auth().signInWithEmailAndPassword(payload.email, payload.password)
      .then(response => {       
       
        commit('SET_USER', response.user);
        commit('SET_AUTH', true);

        console.log(response);
        
        dispatch('getUserDetails', response.user.uid);

      })
      .catch(function(error) {
        commit('SET_USER', null);
        commit('SET_AUTH', false);
      })
      .finally(function(error) {
        dispatch('SET_APP_LOADING_STATE', false);
      });

    },

    guestLogin({ commit, dispatch }) {

        dispatch('SET_APP_LOADING_STATE', true);
   
        firebase.auth().signInAnonymously()
        .then(response => {       
          
          commit('SET_USER', response.user);
          commit('SET_AUTH', true);

          dispatch('getUserDetails', response.user.uid);

        })
        .catch(function(error) {
          commit('SET_USER', null);
          commit('SET_AUTH', false);
          console.log('guest login error', error);
          
        })
        .finally(function(error) {
          dispatch('SET_APP_LOADING_STATE', false);
        });

    },

    userSignout({dispatch}){
      
      dispatch('SET_APP_LOADING_STATE', true);

      firebase.auth().signOut().then(function() {
        console.log('Signed Out');
      }, function(error) {
        console.error('Sign Out Error', error);
      })
      .finally(function(error) {
        dispatch('SET_APP_LOADING_STATE', false);
      });
    },

    createOrder({commit, state}, payload){

      var userId = firebase.auth().currentUser.uid;

      var userDetails = {...payload.user, ...state.details};
        
      var orderPost =  {
        config: state.config,
        createdAt : new Date(),
        owner : userId,
        order: state.order
      };

      return new Promise((resolve, reject) => {
        
        db.collection('orders').add(orderPost).then((orderData) => {
          commit('SET_ITEMS', []);

          db.collection('users').doc(userId).set({...userDetails}, {merge: true}).then((userData) => {
            
            resolve({path: orderData.path});

          });

          
        })
        .catch((error) => {
          console.log(error);
          
          reject(error);
        });

      });
      
    },

    userJoin({ commit }, { email, password }) {
     //New or transformed user
    },

    UPDATE_USER_DETAILS(context, payload) {

      db.collection('users').doc(context.state.user.uid).set({
        email: payload.email,
        phone:payload.phone
      });
      
    },
    
    SET_APP_LOADING_STATE(context, payload) {
      context.commit('SET_APP_LOADING_STATE', payload);
    },

    loadModelData:  function ({commit, dispatch}) {

  
      dispatch('SET_APP_LOADING_STATE', true);
      
      return new Promise(async (resolve, reject) => {
          

          const response =  await Modelservice.getModels({});
          // console.log('response received', response.data);
          
          commit('SET_MODEL_DATA', response.data );
          dispatch('SET_APP_LOADING_STATE', false);

            resolve(response.data);  
          }, error => {
              
              reject(error);
          });

    },
  
    LOAD_PRESETS: async function (context) {
      const response = await Modelservice.getModels({ model: 'presets' });
      context.commit('SET_APP_DATA', { presets: response.data });
    },

    LOAD_SECTIONS: async function (context) {
        const response = await Modelservice.getModels({ model: 'sections' });
        context.commit('SET_APP_DATA', { sections: response.data });
    },

    LOAD_ADDONS: async function (context) {
        const response = await Modelservice.getModels({ model: 'addons' });
        context.commit('SET_APP_DATA', { addons: response.data });
    },

    UPDATE_SETTING: function(context, payload){


      if(context.state.selectedItem){
        //Send and store target item with the mutation for history purpose.
        payload.item = context.state.selectedItem;
        payload.path = context.state.selectedPath;
        context.commit('UPDATE_SETTING', payload);
      }
    },

    UPDATE_ADDONS(context, payload){
      if(context.state.selectedItem){
        //Send and store target item with the mutation for history purpose.
        payload.item = context.state.selectedItem;
        payload.path = context.state.selectedPath;
        context.commit('UPDATE_ADDONS', payload)
      }
    },

    LOAD_ATTRIBUTES: async function (context) {
      const response = await Modelservice.getModels({ model: 'attributes' });
      context.commit('SET_APP_DATA', { attributes: response.data })
    },

    LOAD_MODELS: async function (context) {
      const response = await Modelservice.getModels({ model: 'models' });
      context.commit('SET_APP_DATA', { models: response.data })
    },

    LOAD_MEDIA: async function (context) {
      const response = await Modelservice.getModels({ model: 'media' });

      context.commit('SET_APP_DATA', { media: response.data })
    },

    SET_OPTIONS: function(context, payload){
      context.commit("SET_OPTIONS", payload);
    },

    ADD_ITEM: function(context, payload){

        payload.itemKey = Math.floor(Math.random()*10000) + payload.id;
        context.commit("ADD_ITEM", payload);
    },

    ADD_GROUP: function(context, payload){

      return new Promise((resolve, reject) => {
          context.commit("ADD_GROUP", payload);
          resolve();
      })
    },


    MOVE_ITEM_OLD:function(context, payload){
      context.commit("MOVE_ITEM", payload);
    },

    MOVE_ITEM:function(context, payload){
      
      if(payload.new >= context.state.config[payload.group_index].items.length){
      //Going outside group to the right
        
        if(typeof context.state.config[payload.group_index + 1] !== 'undefined' && context.state.config[payload.group_index + 1].settings.hasOwnProperty('open') && context.state.config[payload.group_index + 1].settings.open){
        //A group exists to the right

          //Move item
          if(context.state.config[payload.group_index + 1].items.length < 3){
            context.commit("MOVE_ITEM", {
              target_group: payload.group_index + 1,
              source_group: payload.group_index,
              target_index: 0,
              source_index: payload.old
            });
            return;
          }

        }else if(context.state.config[payload.group_index].items.length > 1){
        //No OPEN group exists to the right

          var new_item = context.state.config[payload.group_index].items[payload.old];

          context.commit("REMOVE_ITEM", {
            group_index: payload.group_index,
            index: payload.old
          });

          context.commit("ADD_GROUP", {
            index: payload.group_index + 1,
            id: context.state.buildMode.frame_type,
            items:[JSON.parse(JSON.stringify(new_item))],
            settings: {
              ...new_item.settings,
              addons: context.state.config[payload.group_index].settings.addons
            },
          });

          context.commit("EDIT_ITEM",{
            item:context.state.config[payload.group_index + 1].items[0],
            path:[payload.group_index + 1,0]
          });

        }
      }else if(payload.new < 0){

        //console.log(context.state.config[payload.group_index - 1]);
        
        if(typeof context.state.config[payload.group_index - 1] !== 'undefined' && context.state.config[payload.group_index - 1].settings.hasOwnProperty('open') && context.state.config[payload.group_index - 1].settings.open){
        //A group exists to the left
  
            //Move item
            if(context.state.config[payload.group_index - 1].items.length < 3){
              context.commit("MOVE_ITEM", {
                target_group: payload.group_index - 1,
                source_group: payload.group_index,
                target_index: context.state.config[payload.group_index - 1].items.length,
                source_index: payload.old
              });
              return;
            }
  
        }else if(context.state.config[payload.group_index].items.length > 1){

        var new_item = context.state.config[payload.group_index].items[payload.old];

          //No OPEN group exists to the left
          context.commit("REMOVE_ITEM", {
            group_index: payload.group_index,
            index: payload.old
          });

          context.commit("ADD_GROUP", {
            index: payload.group_index,
            id: context.state.buildMode.frame_type,
            items:[JSON.parse(JSON.stringify(new_item))],
            settings: {
              ...new_item.settings,
              addons: context.state.config[payload.group_index].settings.addons
            }
          });

          context.commit("EDIT_ITEM",{
            item:context.state.config[payload.group_index].items[0],
            path:[payload.group_index,0]
          });
        }
      }else{
        
        //Move item
          context.commit("MOVE_ITEM", {
            target_group: payload.group_index,
            source_group: payload.group_index,
            target_index: payload.new,
            source_index: payload.old
          });
       
        
      }

      // if(payload.new < 0){


      //   //Going outside group to the left
      //   if(typeof context.state.config[payload.group_index - 1] !== 'undefined'){
      //     if(context.state.config[payload.group_index - 1].items.length < 3){
      //       payload.mode = 'left';
      //     }
      //   }else{
      //     payload.mode = 'left_new';
      //   }

       
      // }

      // context.commit("ADD_GROUP", {
      //   index: payload.group_index + 1,
      //   items:[],
      //   settings: 
      // });

      // context.commit("MOVE_ITEM_NEW", payload);

  
    },

    REMOVE_ITEM: function(context, payload){
      context.commit("REMOVE_ITEM", payload);
      context.commit("EDIT_ITEM", {
        item:{},
        path:null
      });
    },

    MOVE_GROUP: function({commit, state}, payload){

      var targetIndex = payload.old + payload.new;

      var tempConfig = state.config.map(a => a);
      
      if (targetIndex >= tempConfig.length) {
        var k = targetIndex - tempConfig.length + 1;
        while (k--) {
          tempConfig.push(undefined);
        }
      }

      if(typeof tempConfig[targetIndex] !== 'undefined'){
        commit("MOVE_GROUP", payload);
      }
    },

    REMOVE_GROUP: function(context, payload){
      if(payload.hasOwnProperty('index')){
        context.commit("REMOVE_GROUP", payload);
        context.commit("EDIT_ITEM", {item:{}, path:[]});
      }
    },

    EDIT_ITEM: function(context, payload){      
      context.commit("EDIT_ITEM", payload);
    },

    SET_STAGE_SCALE: function(context, payload){
      context.commit("SET_STAGE_SCALE", payload);
    }
    
  },

  getters:{

    getHistory({history}){
      return history;
    },

    secondaryContent(state){

      if(state.selectedItem && state.selectedItem !== null &&  Object.keys(state.selectedItem).length > 0 && state.selectedItem.constructor === Object){
        return 'settings';
      }

      if(state.options.showSummary && state.config.length > 0){
        return 'summary';
      }

      else{
        return 'products';
      }
    },

    configuration({config}){
      return config;
    },

    configurationItems({config}){
      var count = 0;
      for(var i=0;i < config.length;i++){

        var addonCount = (config[i].hasOwnProperty('settings') && config[i].settings.hasOwnProperty('addons'))?Object.values(config[i].settings.addons).filter((val) => val === true).length:0;
          count += addonCount;

        for(var j=0;j<config[i].items.length;j++){
          count++;
          var addonCount = (config[i].items[j].hasOwnProperty('settings') && config[i].items[j].settings.hasOwnProperty('addons'))?Object.values(config[i].items[j].settings.addons).filter((val) => val === true).length:0;
          count += addonCount;
        }
        
      }
      return count + config.length;
    },

    isAuthenticated({isAuthenticated}){
      return isAuthenticated;
    },

    getCurrentViewport({stage}){
      return stage.settings.viewport;
    },

    currentUser({user}){
      return user;
    },

    currentOrder({order}){
      return order;
    },

    stageObject({stage}){
      return stage;
    },

    stageSettings({stage}){
      return stage.settings;
    },

    frameType({buildMode}){
      return buildMode.frame_type;
    },

    appIsLoading({app}){
      return app.isLoading;
    },

    selectedItem({selectedItem}){
      return selectedItem;
    },
    
    options ({options}) {
      return options;
    },

    mediabank ({modelData}) {
      return modelData.media;
    },


    getTextures({modelData}, getters){

      return (keys) => {

        var textures = [];

        for (let index = 0; index < keys.length; index++) {
          const key = keys[index];
          textures.push(getters.getTexture(key));
        }
      
        return textures.join(',');
      }

    },

    getTexture({modelData}){

      return (id) => {

        if(modelData.media.hasOwnProperty(id)){

          var texture = modelData.media[id];

          switch(texture.type){

            case 'sprite':
              texture = `url(${texture.value}) ${texture.options}`;
              break;

            case 'gradient':
              texture = [texture.value, ' ', texture.options].join('');
              break;

            default:
              texture = texture.value;
              break;

          }
          
          return texture;
        }
      }
    },

    products ({modelData}) {

      var products = [], key;

      for (key in modelData.sections) {

          if (modelData.sections.hasOwnProperty(key) && modelData.sections[key].category === 'standard') {
            products.push(
              {
                id:key,
                type: modelData.sections[key].type,
                name: modelData.sections[key].name, 
                settings: modelData.sections[key].settings, 
                tags: modelData.sections[key].tags, 
                icon: modelData.sections[key].icon
              }
            );
          }
      }      

      return products;
        
    },

    addons ({modelData}) {

      var addons = [], key;

      for (key in modelData.addons) {

          if (modelData.addons.hasOwnProperty(key)) {
            addons.push(
              {
                id:key,
                name: modelData.addons[key].name, 
                icon: modelData.addons[key].icon
              }
            );
          }
      } 

      return addons;
        
    },

    frames ({modelData}) {

      var products = [], key;

      for (key in modelData.sections) {

          if (modelData.sections.hasOwnProperty(key) && modelData.sections[key].category === 'frames') {
            products.push(
              {
                id:key,
                type: modelData.sections[key].type,
                name: modelData.sections[key].name, 
                settings:{},
                icon: modelData.sections[key].icon
              }
            );
          }
      }

      return products;
        
    },

    presets ({modelData}) {

      var presets = [], key;

      for (key in modelData.presets) {

          if (modelData.presets.hasOwnProperty(key)) {

            var extendObj = modelData.sections[modelData.presets[key].extends];
            var presetObj = modelData.presets[key];

            presets.push(
              {
                id:extendObj.id,
                type: extendObj.type,
                name: presetObj.name || extendObj.name, 
                settings:{...extendObj.settings, ...presetObj.settings},
                icon: presetObj.icon || extendObj.icon,
              }
            );
          }
      }

      return presets;
        
    },

    all_products({modelData},getters) {
      
      var prodlist =  getters.products.concat( getters.presets);
      
      prodlist.sort((a, b) => {
        if(a.type === 'frame'){
          return 1;
        }
        return -1;
      });
      
      return prodlist;
    
    },

    all_sections: state => state.modelData.sections,
    all_models: state => state.modelData.models,
    all_addons: state => state.modelData.addons,
    all_attributes: state => state.modelData.attributes
  }

})
